export default __webpack_public_path__ + "static/media/NMC_21.d57236cc.svg";